<template>disableP2PSaveVoice
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="middle-panel" @click.stop>
                <div class="dialog-title">
                    <span v-t="'message.item_save_peer_voice_setting'"></span>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form label-width="200px" class="dialog-form-item">
                        <el-form-item prop="methodType" ref="methodType">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_save_peer_voice'"></span>
                            </div>
                            <el-select class="select-option-item" v-model="disableP2PSaveVoice" @change="handleOptionChange()" >
                                <el-option v-for="disableP2PSaveOption in disableP2PSaveOptions" :key="disableP2PSaveOption.displayName" :label="disableP2PSaveOption.displayName" :value="disableP2PSaveOption.value" ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.$data.okButton" @click="saveChange()" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';

export default {
    data() {
        return {
            disableP2PSaveVoice: false,
            okButton: true,
            disableP2PSaveOptions: [],
        };
    },
    methods: {
        saveChange: function() {
            this.$emit('save', this.disableP2PSaveVoice);
        },
        handleOptionChange: function() {
            this.okButton = (this.disableP2PSaveVoice == this.appData.disableP2PSaveVoice);
        },
    },
    created: function() {
        this.disableP2PSaveVoice = this.appData.disableP2PSaveVoice;
        this.disableP2PSaveOptions = [
            { value: false ,displayName: commonUtil.getMessageText(this.$i18n,"item_save") },
            { value: true  ,displayName: commonUtil.getMessageText(this.$i18n,"item_no_save") }
        ];
    },
    props: {
        appData: {}
    }
}
</script scoped>

<style scoped>
button.input-pass-check {
    border-style: none;
    background-color: #fff;
    cursor: pointer;
    outline: none;
    position: absolute;
    height: 20px;
    width: 44px;
    left: 305px;
    top: 2px;
    z-index: 10;
    color: #848991;
    font-size: 10px;
}
.el-select.select-two-phase-method-item {
    width: 350px;
}
.middle-panel {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    width: 580px;
    max-height: 80vh;
    margin-top: -40vh;
    margin-left: -250px;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
}

</style>
